import { FileInfoDisplayResultDto } from '../../_models/file-info-display-result-dto';
import { Type } from 'class-transformer';

export class WFInvoiceHistoryResultDto {
    workflowId: number;

    @Type(() => FileInfoDisplayResultDto)
    invoiceFileInfo: FileInfoDisplayResultDto; // 	contains file name and download url

    invoiceNumber: string;

    @Type(() => Date)
    invoiceDate: Date;

    invoiceAmount: number;
    amountToPay: number;
    status: string;
    handling: string;
    isEFT: boolean; // 	Indicates if work flow payment is by EFT

    @Type(() => Date)
    paymentDate: Date;

    paymentNumber: string;
    hasNotes: boolean; // 	Indicates if work flow has notes
    paymentId: number;
    vendorAccountNumber: string;
    paymentCleared: boolean;
}
